var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import { css, styled } from '@creditas-ui/system';
import { ifProp, getTypography } from '@creditas-ui/utilities';
import { Box } from '@creditas-ui/layout';
export var base = function base(_ref) {
  var button = _ref.theme.button;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  border: none;\n  overflow: hidden;\n  color: ", ";\n  background-color: transparent;\n  transition: all ", ";\n  padding: ", ";\n"])), button('secondary.fontColor'), button('secondary.transitionMotion'), button('secondary.padding'));
};
export var disabled = function disabled(_ref2) {
  var button = _ref2.theme.button;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  cursor: not-allowed;\n"])), button('secondary.disabledFontColor'));
};
export var hover = function hover(_ref3) {
  var button = _ref3.theme.button;
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  opacity: ", ";\n"])), button('secondary.opacityHover'));
};
export var ButtonSecondaryElement = styled(Box.withComponent('button'))(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", ";\n\n  &:hover {\n    ", ";\n  }\n"])), getTypography('bodyMdMedium'), base, ifProp({
  disabled: true
}, disabled), ifProp({
  disabled: false
}, hover));